import React, { Fragment } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import BlogBannerSection from "../../components/Blog-Sections/Banner";
import BlogPostsList from "../../components/Blog-Sections/Posts";
import HeadSection from "../../components/meta";
import BannerAd from "../../components/Ads/bannerAd";


const Blog = () => {
  return (
    <Fragment>
      <HeadSection
        title={"BLOG"}
        keywords={""}
        addPostFixTitle={true}
        largeTwitterCard={true}
        showCanonical={true}
        content={
          "Empower yourself with Seed to Tree—your tech blog & academy for mastering AI, software, and IT. Discover expert tutorials and digital solutions to unlock your potential."
        }
        link={`/blog`}
      />
      <Header isActive="blog" />
      <BlogBannerSection />
      <BannerAd />
      <BlogPostsList />
      <Footer />
    </Fragment>
  );
};

export default Blog;
